<template>
  <br />
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <!-- FILTROS -->
  <div class="row" style="width: 100%">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3">
              <label for="conjuge_data_emissao_rg">Leilões agendados entre</label>
              <div class="form-group">
                <InputMask
                  id="dataInicio"
                  class="form-control"
                  v-model="dataInicial"
                  placeholder="__/__/____"
                  mask="99/99/9999"
                  slotChar="__/__/____"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <label for="conjuge_data_emissao_rg">às</label>
              <div class="form-group">
                <InputMask id="dataInicio" class="form-control" v-model="horaInicial" placeholder="00:00" mask="99:99" slotChar="00:00" />
              </div>
            </div>
            <div class="col-sm-3">
              <label for="conjuge_data_emissao_rg">Até</label>
              <div class="form-group">
                <InputMask id="dataFim" class="form-control" v-model="dataFinal" placeholder="__/__/____" mask="99/99/9999" slotChar="__/__/____" />
              </div>
            </div>
            <div class="col-sm-3">
              <label for="conjuge_data_emissao_rg">às</label>
              <div class="form-group">
                <InputMask id="dataInicio" class="form-control" v-model="horaFinal" placeholder="00:00" mask="99:99" slotChar="00:00" />
              </div>
            </div>
          </div>

          <button @click="buscarLeiloes()" style="border-radius: 2px" type="submit" class="btn btn-info">Filtrar</button>
          <button @click="limparFiltros()" style="border-radius: 2px" type="submit" class="btn btn-default">Limpar filtros</button>
        </div>
      </div>
    </div>
  </div>

  <div style="padding: 0px 0px 10px 0px; color: red" v-if="searchBuscado">Exibindo resultados para "{{ filtro }}"</div>

  <div class="row" style="width: 100%" id="leiloes">
    <div class="col-6 col-sm-12 col-md-4 md-div" v-for="leilao in leiloes" :key="leilao" :value="leilao" v-if="leiloes">
      <agenda-card :leilao="leilao" />
    </div>

    <div class="col-sm-12" v-if="leiloes">
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + leiloes.length }}
          <p>Total {{ total }}</p>
        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px">
            <!--
            <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

            <select @change="alterarQtdPagina()" class="card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
              <option :value="3">3</option>
              <option :value="12">12</option>
              <option :value="24">24</option>
              <option :value="48">48</option>
              <option :value="96">96</option>
            </select>[-->
          </div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import InputMask from "primevue/inputmask";
import moment from "moment";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal],

  props: [],

  components: { Loading, InputMask },

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      leiloes: "",
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 15,
      filtro: "",
      pagina_atual: 1,
      searchBuscado: false,
      dataInicial: "",
      dataFinal: "",
      horaInicial: "",
      horaFinal: "23:59",
    };
  },

  mounted() {
    console.log("Todos os leilões");
    this.buscarLeiloes();
    console.log(this.leiloes);

    if (window.history.state) {
      this.limparFiltros();
    }

    //window.addEventListener("popstate", this.handlePopState);
  },

  beforeDestroy() {
    console.log("BEFORE DESTROY");
    window.removeEventListener("popstate", this.handlePopState);
  },

  methods: {
    handlePopState() {
      console.log("restando filtros");

      this.limparFiltros();
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLeiloes();
    },

    limparFiltros() {
      console.log("Limpando logs");

      this.horaInicial = "00:00";
      this.horaFinal = "23:59";
      this.dataInicial = "";
      this.dataFinal = "";
      this.filtro = "";

      document.getElementById("dataInicio").value = "";
      document.getElementById("dataFim").value = "";

      this.buscarLeiloes();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else if (!this.validateEmail()) {
        this.showErrorMessageWithButton("Ops...", "Digite um email válido!");
      } else if (this.senha == "") {
        this.showErrorMessageWithButton("Ops...", "A senha não pode ficar em branco!");
      } else {
        this.create();
      }
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLeiloes();
      }
    },

    buscarLeiloes() {
      this.isLoading = true;

      let data = {
        search: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      if (this.dataInicial) {
        let aux_dataInicio = this.formatDateToSearch(this.dataInicial +" "+ this.horaInicial);
        data.data_inicio = aux_dataInicio;
      }

      if (this.dataFinal) {
        let aux_dataFim = this.formatDateToSearch(this.dataFinal +" "+ this.horaFinal);
        data.data_fim = aux_dataFim;
      }

      console.log("Busca");
      console.log(data);

      axios
        .post(`/agenda/search`, data)
        .then((response) => {
          this.isLoading = false;

          console.log(response.data);

          if (this.filtro && this.filtro != "") {
            this.searchBuscado = true;
          } else {
            this.searchBuscado = false;
          }

          this.leiloes = response.data.leiloes;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDateToSearch(date) {
      console.log("Formatando data "+ date);
      return moment(date, "DD/MM/yyyy HH:mm").format("yyyy-MM-DD HH:mm");
    },

    formatDateToSearchTime(date) {
      return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD 23:59:59");
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}
</style>
